module.exports = __webpack_public_path__ + "assets/img/restaurant-icon.69925618.png";